import { Flex } from "@mantine/core";
import { CSSProperties } from "react";

import { useLotNames } from "~/hooks/Gmp/useLotNames";
import { useDialog } from "~/hooks/useDialog";
import { ALL_LOTS } from "~/utils/Constants";

import Chip from "./Chip";
import LotNameEditDialog from "./LotNameEditDialog";

type LotNameChipProps = {
  lotReference: string;
  killDate: string;
  headCount?: number;
  size?: "small" | "medium";
  style?: CSSProperties;
};

const LotNameChip = ({
  lotReference,
  killDate,
  headCount,
  size = "small",
  style,
}: LotNameChipProps) => {
  const { getNameForLot } = useLotNames();
  const editDialog = useDialog();

  const isAllLots = lotReference === ALL_LOTS;
  const name = getNameForLot(lotReference, killDate);

  const getLabel = () => {
    if (isAllLots) {
      return `Lot: ${lotReference} | Head: ${headCount}`;
    }
    if (name) {
      return `${name}`;
    }
    return `Lot: ${lotReference} | Head: ${headCount}`;
  };

  return (
    <>
      <Flex direction="row" align="center" gap={4}>
        <Chip
          label={getLabel()}
          size={size}
          style={{
            cursor: isAllLots ? "default" : "pointer",
            ...style,
          }}
          onClick={isAllLots ? undefined : editDialog.open}
          tooltipTitle={isAllLots ? undefined : "Click to edit lot description"}
        />
      </Flex>

      {!isAllLots && (
        <LotNameEditDialog
          open={editDialog.isOpen}
          onClose={editDialog.close}
          lotReference={lotReference}
          killDate={killDate}
          currentName={name}
          headCount={headCount}
        />
      )}
    </>
  );
};

export default LotNameChip;
